// Keys are contract: the service labels its entries with these and the request selects
// sources by them, so they are named after the entity they belong to.
export const RiskCalendarEventTypes = {
  Reported: {
    key: "risk.reported",
    label: "Reported",
    description: "When the risk was raised",
    color: "minor",
  },
  ReviewDue: {
    key: "risk.review-due",
    label: "Review due",
    description: "When the next review falls due",
    color: "major",
  },
  ExpectedClosure: {
    key: "risk.expected-closure",
    label: "Expected closure",
    description: "When the risk is planned to close",
    color: "themeBlue",
  },
  TreatmentDue: {
    key: "treatment.due",
    label: "Treatment due",
    description: "Active treatments, including overdue",
    color: "moderate",
  },
};

export const RiskCalendarEventLegendItems = Object.values(RiskCalendarEventTypes);
